
<template>
  <div class="m-operateLog">
    <div class="top-back">
      <div class="title-back w60" @click="$router.replace('/administration')">返回</div>
    </div>
    <div class="operateLog-main">
      <el-form ref="formInline" label-width="70px">
        <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
          <el-col :span="6">
            <el-form-item label="操作时间">
              <el-date-picker
                v-model="formInline.originatingTime"
                type="daterange"
                style="width: 100%"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="用户">
              <el-input v-model="formInline.userName" placeholder="请输入用户" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="登录账号">
              <el-input v-model="formInline.loginAccount" placeholder="请输入登录账号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="模块">
              <el-input v-model="formInline.moduleCascadeName" placeholder="请输入模块" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="事件">
              <el-input v-model="formInline.eventName" placeholder="请输入事件名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <div class="flex-end">
              <el-button type="primary" plain @click="getReset()">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="getList">搜 索</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData" height="100%" style="width: 100%">
        <el-table-column label="序号" prop="xh" width="150" />
        <el-table-column prop="userName" label="用户" width="120" />
        <el-table-column prop="loginAccount" label="登录账号" width="150" />
        <el-table-column prop="createTime" label="操作时间" width="180" />
        <el-table-column prop="platform" label="平台" width="120" />
        <el-table-column prop="moduleName" label="模块" />
        <el-table-column prop="eventName" label="事件" width="180" />
        <el-table-column prop="address" label="操作" width="120">
          <template slot-scope="scope">
            <el-button v-permission="['112041003']" type="text" @click="getInfo(scope.row)">
              查看详细
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :background="false"
        :limit.sync="page.pageSize"
        :page.sync="page.pageNum"
        :total="tableTotal"
        @pagination="getList('page')"
      />
    </div>
  </div>
</template>

<script>
import { logList } from '@/api/mainData/operateLog'

export default {
  name: 'OperateLog',
  components: {},
  data() {
    return {
      approveUserList: [],
      tableData: [],
      formInline: {
        userName: null, // 用户
        moduleCascadeName: null, // 模块
        loginAccount: null, // 登录账号
        startDate: null,
        endDate: null,
        eventName: '', // 事件名称
        originatingTime: []
      },
      options: [],
      userOptions: [],
      loading: false,
      userLoading: false,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      tableTotal: 0
    }
  },
  computed: {},
  watch: {
    'formInline.originatingTime'(val) {
      if (val) {
        this.formInline.startDate = val[0]
        this.formInline.endDate = val[1]
      } else {
        this.formInline.startDate = null
        this.formInline.endDate = null
      }
    }

  },
  created() {
    if (sessionStorage.getItem('searchFlag')) {
      this.formInline = JSON.parse(sessionStorage.getItem('nowRequirePageData'))
      this.getList()
    } else {
      sessionStorage.removeItem('nowRequirePageData')
      this.getList()
    }
  },
  mounted() {
    if (sessionStorage.getItem('searchFlag')) {
      this.formInline = JSON.parse(sessionStorage.getItem('nowRequirePageData'))
    } else {
      sessionStorage.removeItem('nowRequirePageData')
    }
  },
  destroyed() {
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    // 重置
    getReset() {
      this.$refs.formInline.resetFields()
      this.approveUserList = []
      this.formInline.originatingTime = []
      this.formInline.startDate = null
      this.formInline.endDate = null
      this.formInline.userName = ''
      this.formInline.moduleCascadeName = ''
      this.formInline.loginAccount = ''
      sessionStorage.removeItem('searchFlag')
      this.getList()
    },
    getList(state = '') {
      if (state !== 'page') {
        this.page.pageNum = 1
        this.page.pageSize = 10
      }
      const params = {
        ...this.formInline,
        pageParam: {
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize
        }
      }
      const load = this.$load()
      logList(params, this.formInline.enterpriseUuid).then((res) => {
        this.tableData = res.data.list || []
        this.tableTotal = res.data.page.total
        load.close()
      }).catch(e => {
        load.close()
      })
    },
    // 查看详情
    getInfo(val) {
      const _data = Object.assign(this.formInline)
      sessionStorage.setItem('nowRequirePageData', JSON.stringify(_data))
      this.$router.push({
        path: '/mainData/operateLog/info',
        query: { logId: val.logId }
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
